import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App';
import { LogInSchoolID } from '../../JS/Common';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { useDispatch } from 'react-redux';
import { setDefaultTicketStatus } from '../../Store/Slices/authSlice';
import SettingBoxWrapper from './SettingBoxWrapper';

export default function SendOutForRepairDetails({ setLoading, setNewAlerts }) {
    const { UserData, setUserData } = useContext(UserContext);
    const reduxDispatch = useDispatch();
    const [SendOutRepairFlag, setSendOutRepairFlag] = useState(UserData.sendOutForRepairFlag)
    useEffect(() => {
        setSendOutRepairFlag(UserData.sendOutForRepairFlag)
    }, [UserData.sendOutForRepairFlag])
    async function SendOutForRepairCall() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            flag: SendOutRepairFlag
        })
        await ApiPostCall("/settings/default-ticket-status", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Send Out for Repair Setting Updated Successfully"} />);
                    setTimeout(() => {
                        setUserData((prevUserData) => ({ ...prevUserData, sendOutForRepairFlag: SendOutRepairFlag }));
                        if (UserData.copyaccesstype != null) {
                            reduxDispatch(setDefaultTicketStatus(SendOutRepairFlag));
                        }
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    return (
        <>
            <SettingBoxWrapper
                BoxTitle={'Send Out for Repair'}
                BoxLabel={`Would you like Set 'Send Out for Repair' as the default status for new tickets?`}
            >
                <div className='col-md-12 mt-3 d-flex align-items-center'>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='SendOutTicket'
                            onChange={(e) => setSendOutRepairFlag(1)}
                            defaultChecked={SendOutRepairFlag == 1}
                        />
                        <label className="form-check-label">Yes</label>
                    </div>
                    <div className="form-check ms-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='SendOutTicket'
                            onChange={(e) => setSendOutRepairFlag(0)}
                            defaultChecked={SendOutRepairFlag != 1}
                        />
                        <label className="form-check-label">No</label>
                    </div>
                    <div className='px-5'>
                        <button className="SaveBtn" onClick={SendOutForRepairCall}> Confirm   </button>
                    </div>
                </div>
            </SettingBoxWrapper>
        </>
    )
}
